import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
 
export const CustomSwitch = styled(Switch)(({ theme,togglecolour,backgroundtheme }) => ({
  padding: 8,
 
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    backgroundColor: "#D3D6DD",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 200,
    }),
 
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
      color: "#707B90",
    },
    "&::before": {
      left: 12,
    },
    "&::after": {
      right: 12,
    },
  },
 
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    color: togglecolour,
  },
 
  /* ✅ WHEN SWITCH IS ON */
  "& .MuiSwitch-switchBase.Mui-checked": {
    transform: "translateX(20px)",
    "& .MuiSwitch-thumb": {
      backgroundColor: "#FFFFFF",
    },
 
    "& + .MuiSwitch-track": {
      backgroundColor: backgroundtheme,
      opacity: 1,
    },
//     "& .MuiSwitch-thumb": {
//     boxShadow: "none",
//     width: 16,
//     height: 16,
//     margin: 2,
//     color: "#0065FF",
//   },
  },
 
  /* Optional: Disabled state */
  "& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track": {
    opacity: 0.4,
  },
}));